import type { getContentTypeName } from "scmp-app/components/content/helpers";

export const getFallbackLink = (contentType: ReturnType<typeof getContentTypeName>) => {
  switch (contentType) {
    case "gallery":
      return "/photos";
    case "video":
      return "/video";
    default:
      return;
  }
};
